import { useEffect, useState } from "react";
import { Transition } from "@headlessui/react";
import { userService } from "../../services/user.service";

export default function ChangePasswordModal(props) {
  const [open, setOpen] = useState(false);
  const [inputs, setInputs] = useState({});
  const [error, setError] = useState("");

  const handleClose = () => {
    props.setOpen(false);
    //setOpen(false);
  };

  const handleChange = (e) =>
    setInputs((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));

  const changePasswordClick = async (e) => {
    setError("");
    const result = await userService.updatePassword(
      inputs.currentPassword,
      inputs.newPassword,
      inputs.repeatNewPassword
    );

    if (result.status === 400) {
      setError(result.data.message);
    } else {
      handleClose();
    }
  };

  useEffect(() => {
    setOpen(props.open);
  }, [props.open]);

  return (
    <Transition
      show={open}
      enter="transition-opacity duration-500"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-500"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto overflow-x-hidden outline-none focus:outline-none">
        <div className="relative my-6 mx-auto w-auto max-w-sm">
          {/*content*/}
          <div className="relative flex w-full flex-col rounded-lg border-0 bg-white shadow-lg outline-none focus:outline-none">
            {/*header*/}
            <div className="flex items-start justify-between rounded-t border-b border-solid border-slate-200 p-5">
              <h3 className="text-xl font-semibold">Change Password</h3>
              <button
                className="float-right ml-auto border-0 bg-transparent p-1 text-3xl font-semibold leading-none text-black opacity-5 outline-none focus:outline-none"
                onClick={handleClose}
              >
                <span className="block h-6 w-6 bg-transparent text-2xl text-black opacity-5 outline-none focus:outline-none">
                  ×
                </span>
              </button>
            </div>
            {/*body*/}
            <div className="relative flex-auto p-6">
              <div className="mb-2 flex flex-col">
                <div className="relative flex ">
                  <input
                    onChange={handleChange}
                    type="password"
                    name="currentPassword"
                    id="currentPassword"
                    className="w-full flex-1 appearance-none rounded-lg border border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600"
                    placeholder="Current Password"
                  />
                </div>
              </div>
              <div className="mb-2 flex flex-col">
                <div className="relative flex ">
                  <input
                    onChange={handleChange}
                    type="password"
                    name="newPassword"
                    id="newPassword"
                    className="w-full flex-1 appearance-none rounded-lg border border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600"
                    placeholder="New Password"
                  />
                </div>
              </div>
              <div className="mb-6 flex flex-col">
                <div className="relative flex ">
                  <input
                    onChange={handleChange}
                    name="repeatNewPassword"
                    type="password"
                    id="repeatNewPassword"
                    className="w-full flex-1 appearance-none rounded-lg border border-gray-300 bg-white py-2 px-4 text-base text-gray-700 placeholder-gray-400 shadow-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-purple-600"
                    placeholder="Repeat New Password"
                  />
                </div>
              </div>
              {error && (
                <div
                  className="border-l-4 border-red-600 bg-red-200 p-4 text-red-600"
                  role="alert"
                >
                  <p>{error}</p>
                </div>
              )}
            </div>
            {/*footer*/}
            <div className="flex items-center justify-end rounded-b border-t border-solid border-slate-200 p-6">
              <button
                className="background-transparent mr-1 mb-1 px-6 py-2 text-sm font-bold uppercase text-red-500 outline-none transition-all duration-150 ease-linear focus:outline-none"
                type="button"
                onClick={handleClose}
              >
                Close
              </button>
              <button
                className="mr-1 mb-1 rounded bg-emerald-500 px-6 py-3 text-sm font-bold uppercase text-gray-900 shadow outline-none transition-all duration-150 ease-linear hover:bg-emerald-400 hover:shadow-lg focus:outline-none active:bg-emerald-600"
                type="button"
                onClick={changePasswordClick}
              >
                Change Password
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="fixed inset-0 z-40 bg-black opacity-25"></div>
    </Transition>
  );
}
